module.exports = __webpack_public_path__ + "static/img/bg1.ea59538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/bg1.png
// module id = 7yht
// module chunks = 69